<template>
  <div
    data-test-id="DirectoriesList"
  >
    <HeadingExtraSmall
      data-test-id="DirectoriesList__directoriesHeading"
      :hasMargin="false"
    >
      {{ $options.directoriesConfig.label }}
    </HeadingExtraSmall>
    <LoadingIcon
      v-if="isLoading"
      :scale="1.75"
    />
    <ResourceError
      v-else-if="hasError"
      data-test-id="DirectoriesList__directoriesError"
    />
    <ParagraphBody
      v-else
      data-test-id="DirectoriesList__directoriesList"
    >
      {{ getDirectoriesList }}
      <ButtonLink
        v-if="showDirectoriesLink"
        :class="$style.linkText"
        data-test-id="DirectoriesList__directoriesAssignLink"
        :text="$options.directoriesConfig.linkText"
        @click="navigateToTab('Directories')"
      />
    </ParagraphBody>
  </div>
</template>

<script>
import {
  ButtonLink,
  HeadingExtraSmall,
  LoadingIcon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { DirectoryTypeConsts } from 'client/util/Constants/DirectoryConstants';
import { mapActions } from 'vuex';
import ItemType from 'client/util/Constants/ItemType';
import ResourceError from 'client/systemusers/UserDetails/UserResources/ResourceError.vue';

const { DirectoryItemType } = ItemType;
const directoryItemType = new DirectoryItemType();

const directoryCollection = 'DirectoryCollection';
const systemUserModel = 'SystemUserModel';

export default {
  name: 'DirectoriesList',

  components: {
    ButtonLink,
    HeadingExtraSmall,
    LoadingIcon,
    ParagraphBody,
    ResourceError,
  },

  data: () => ({
    directoriesList: [],
    hasError: false,
    isLoading: true,
  }),

  directoriesConfig: {
    label: `${directoryItemType.titlePlural}`,
    linkText: `Assign a ${directoryItemType.label}`,
    zeroStateText: `No ${directoryItemType.labelPlural} have been directly assigned to this user.`,
  },

  skipWorkdayFilter: {
    name: 'type',
    operator: 'ne',
    value: `${DirectoryTypeConsts.workday}`,
  },

  computed: {
    getDirectoriesList() {
      return this.directoriesList.length
        ? this.directoriesList.join(', ')
        : this.$options.directoriesConfig.zeroStateText;
    },

    showDirectoriesLink() {
      return this.directoriesList.length === 0;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(directoryCollection, [
      'fetchCollection',
      'setFilter',
    ]),

    ...mapActions(systemUserModel, ['fetchDirectoryAssociations']),

    async getDirectories() {
      const { associations, errorOccurred } = await this.fetchDirectoryAssociations();

      associations.forEach((association) => {
        this.directoriesList.push(association.name);
      });

      this.directoriesList.sort();
      this.hasError = errorOccurred;
    },

    async handleMounted() {
      /**
       * We do not want Workday in the list of directories; if this filter isn't set,
       * the fetchCollection below will add it back to the list for STAGED users and
       * it will show on the directories tab on the aside
       *
       * @see https://jumpcloud.atlassian.net/browse/DE-2276
       */
      await this.setFilter({ filter: this.$options.skipWorkdayFilter });
      await this.fetchCollection();
      await this.getDirectories();
      this.isLoading = false;
    },

    navigateToTab(tabLabel) {
      this.$emit('changeTab', tabLabel);
    },
  },
};
</script>

<style scoped module>
.linkText.linkText {
  text-transform: none;
}
</style>
